export default "__VITE_ASSET__CzuLuKUB__"